import React from 'react';
import PageTemplate from '../components/PageTemplate';

const AddCategory = () => {
  return (
    <PageTemplate title="Add Category" showFilter={false}>
      {/* Add your content here */}
    </PageTemplate>
  );
};

export default AddCategory;
